import React, { useState } from "react";
import { NASHA_HUB_URL } from "../config";
import { getT } from "../i18n/translations";

// NAŠA HUB exit gate: potvrda da korisnik napušta ovaj sajt i ide na NAŠA HUB.
export const EmailGate = ({ lang, open, onClose }) => {
  const t = getT(lang).gate;
  const [agreed, setAgreed] = useState(false);

  if (!open) return null;

  const close = () => {
    onClose();
    setTimeout(() => setAgreed(false), 250);
  };

  const go = () => {
    if (!agreed) return;
    window.open(NASHA_HUB_URL, "_blank", "noopener,noreferrer");
    close();
  };

  return (
    <div
      data-testid="exit-gate-overlay"
      onClick={close}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 50,
        background: "rgba(22,21,15,0.45)",
        backdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        className="card fade-up"
        data-testid="exit-gate-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ width: "100%", maxWidth: 440, background: "#fff" }}
      >
        <div className="flex items-center justify-between mb-1">
          <h3 style={{ fontWeight: 700, fontSize: 18, margin: 0 }}>NAŠA HUB</h3>
          <button
            data-testid="exit-gate-close"
            onClick={close}
            aria-label="Close"
            style={{
              border: "none",
              background: "transparent",
              fontSize: 22,
              lineHeight: 1,
              cursor: "pointer",
              color: "var(--ink)",
            }}
          >
            ×
          </button>
        </div>

        <p style={{ color: "var(--ink-soft)", marginTop: 6 }}>{t.exitIntro}</p>

        <label
          data-testid="exit-gate-checkbox"
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            marginTop: 14,
            cursor: "pointer",
            fontSize: 14,
            lineHeight: 1.4,
          }}
        >
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            style={{ marginTop: 3, width: 18, height: 18, flexShrink: 0, cursor: "pointer" }}
          />
          <span>{t.exitConfirm}</span>
        </label>

        <button
          data-testid="exit-gate-go"
          type="button"
          onClick={go}
          className="btn btn-primary"
          style={{ marginTop: 16, opacity: agreed ? 1 : 0.5, cursor: agreed ? "pointer" : "not-allowed" }}
          disabled={!agreed}
        >
          {t.exitGo}
        </button>
      </div>
    </div>
  );
};

export default EmailGate;
